import {
  HTTP_CP_GetDashboardData_Response_DashboardDataForMortgageDeals_Mortgage,
  HTTP_CP_MortgageDeal,
} from '@api-new/mortgageservice/index';
import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { BestDealFlagEnum } from '@shared/enums/best-deal-flag.enum';
import { BestDealsBetterDealModel, BestDealsModel } from '@shared/models/best-deals.model';
import { BestBetterDealState } from '@shared/store/best-better-deals/best-better-deals.state';
import { getDashboardDataSuccess } from '@shared/store/common.actions';

export const getBestBetterDealById = (bestBetterDeal: Pick<{ mortgageId: string; deals: HTTP_CP_MortgageDeal[] }, 'mortgageId'>): string =>
  bestBetterDeal.mortgageId;

export const bestBetterDealAdapter: EntityAdapter<{
  mortgageId: string;
  mortgage: HTTP_CP_GetDashboardData_Response_DashboardDataForMortgageDeals_Mortgage | undefined;
  mortgageDeals: HTTP_CP_MortgageDeal[];
  numberOfMortgageDeals?: number;
}> = createEntityAdapter<{
  mortgage: HTTP_CP_GetDashboardData_Response_DashboardDataForMortgageDeals_Mortgage | undefined;
  mortgageId: string;
  mortgageDeals: HTTP_CP_MortgageDeal[];
  numberOfMortgageDeals?: number;
}>({
  selectId: getBestBetterDealById,
});

const bestBetterDealInitialState: BestBetterDealState = bestBetterDealAdapter.getInitialState({
  loading: true,
  errors: null,
});

const buildMortgageBestDeals = (data): BestDealsBetterDealModel[] => {
  const bestDeals: BestDealsBetterDealModel[] = [];
  // set biggest saving
  if (data.mortgageDeals) bestDeals.push({ flag: BestDealFlagEnum.BiggestSaving, ...data.mortgageDeals[0] });
  // set same lender - biggest saving
  if (data.mortgageDealSameLender) bestDeals.push({ flag: BestDealFlagEnum.SameLender, ...data.mortgageDealSameLender });
  // set lowest payment
  if (data.mortgageDealLowestMonthlyPayment)
    bestDeals.push({ flag: BestDealFlagEnum.LowestPayment, ...data.mortgageDealLowestMonthlyPayment });
  return bestDeals;
};

const reducer = createReducer(
  bestBetterDealInitialState,

  on(getDashboardDataSuccess, (state, dashboardData) => {
    if (!dashboardData.mortgageIdToDashboardDataForMortgageDealsMap) {
      return bestBetterDealAdapter.removeAll({
        ...state,
        loading: false,
        errors: null,
      });
    }
    const map = new Map(Object.entries(dashboardData.mortgageIdToDashboardDataForMortgageDealsMap));
    const entities: BestDealsModel[] = [];

    map.forEach((value, key) =>
      entities.push({
        mortgageId: key,
        mortgageDeals: value.mortgageDeals,
        numberOfMortgageDeals: value.numberOfMortgageDeals,
        bestDeals: buildMortgageBestDeals(value),
        mortgage: value.mortgage,
      }),
    );
    return bestBetterDealAdapter.setAll(entities, {
      ...state,
      loading: false,
      errors: null,
    });
  }),
);

export const bestBetterDealsReducer = (state: BestBetterDealState = bestBetterDealInitialState, action: Action): BestBetterDealState =>
  reducer(state, action);
